export default {
  team: 'SuperDaily@TEAM',
  landing: {
    name: 'SuperDaily',
    title: 'Download the app and change your habits',
    download: 'Download the application',
    iosInstallInfo: 'Install the app on your phone. Click the share button and find:',
    iosInstallInfo2: '"To start screen"',
    desktop: {
      title: 'Rozwijaj nawyki online i offline',
      about: 'Pobierz aplikację i zmień swoje nawyki. Aplikacja dostępna na iOS i Android. Zeskanuj kod aparatem w telefonie.',
    },
  },
  friends: {
    invide: 'Zaproś do obserwowania:',
    subscribe: 'Obserwuj znajomego',
    code: 'Twój kod',
    remove: 'Na pewno chcesz przestać obserwować znajomego?',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
  },
  points: {
    yourPoints: 'Twoje punkty:',
  },
  calendar: {
    close: 'Zamknij',
  },
  habits: {
    noHabit: 'Tego dnia nie miałeś żadnych nawyków',
  },
  habit: {
    edit: 'Edycja',
    webhookTitle: 'Rozwijaj nawyk offline',
    changeHour: 'Zmień godzinę',
    showCalendar: 'Pokaz kalendarz',
    remove: 'Usuń nawyk',
    removeDialogTitle: 'Usuwanie nawyku',
    removeDialogText: 'Jesteś pewny, że chcesz usunąć nawyk?',
    removeDialogConfirm: 'usuń',
    removeDialogCancel: 'wyjdź',
    changeTimeDialogMessage: 'Zmień godzinę',
    changeTimeDialogInfo: 'Zmieniłeś godzinę na:',
    webhook: 'Po wejściu na ten link aktywność zostanie zaliczona.'
        + 'Mozesz zapisać link na naklejkę NFC lub wydrukować kod QR'
        + 'a potem potem po zeskanowaniu telefonem, zaliczyć aktywność.',
    addNew: 'Dodaj nowy nawyk',
    pickTimeLabel: 'pick a time',
    clickToSelect: 'Click to select...',
    addHabit: 'Dodaj nawyk',
    closeModal: 'Zamknij',
    IsAlreadyExist: 'taki nawyk jest już aktywny',
  },
  itemModal: {
    title: 'Rozwijanie nawyku offline',
    addNewPassword: 'Dodaj nowe hasło',
    removePassword: 'Usuń hasło',
    password: 'Hasło',
    save: 'Zapisz',
    exit: 'Wyjdź',
    downloadQRCode: 'Pobierz QR Code',
    saveToNFCTag: 'Zapisz na NFC tag',
    writeToNFCTagMessage: 'Zbliz telefon do NFC tagu',
    saveNFCSucces: 'Udało się zapisać kod na NFC!',
    yourPhoneDontSupportNFC: 'Twój telefon nie wspiera obecnie zapisywania NFC z tej aplikajci.',
  },
  account: {
    brandName: 'SuperDaily',
    loginIn: 'Zaloguj się',
    googleSignIn: 'Sign in with google',
    githubLogin: 'Login With Github',
    youAreAnonim: 'Jesteś anonimowy',
    logout: 'Wyloguj się',
    anonimLoginModalTitle: 'Zaloguj się później',
    anonimLoginModalMessage: 'Twoje dane nie są przypisane do zadnego konta e-mail. Wszystkie twoje dane mogą zostaną utracone. Jeśli chcesz, żeby twoje dane się zachowały, skorzystaj z innego sposobu logowania.',
    anonimLoginModalConfirm: 'Zaloguj',
    anonimLoginModalCancel: 'Anuluj',
    youAreOffline: 'Jesteś w trybie offline. Pracujemy nad tym.',
  },
  trial: {
    welcomeInBrand: 'Witaj w SuperDaily!',
    setNick: 'Na początku nadaj nick dla Twojego konta.',
    setingNick: 'Nadawanie nicku',
    toLongNick: 'za długie, max 20 znaków.',
    toShortNick: 'za krótkie, musi być dłuzsze niz 5.',
    onlyLettersAndNumbers: 'tylko zwykłe znaki i cyfry',
    hello: 'Cześć',
    wellcomeMessage: 'miło mi cię poznać. Ja jestem Wojtek. Jestem twórcą SuperDaily. ;)',
    yourFirstTime: 'Jesteś pierwszy raz w aplikacji, dlatego mogę Ci pomóc w zmaksymalizowaniu efektów, które możesz uzyskać z jej używania.',
    canItakeYouMinutes: 'Zajmie to Nam max. 2 minuty. Mogę ci zająć chwilę?',
    letsStart: 'Zaczynamy',
    skipTrial: 'Pomiń wprawadzenie',
    afterSkipTrialMessage: 'OK, zaraz Cię przeniosę do aplikacji',
    thirdStep1: 'Żeby być mistrzem nawyków trzeba najpierw zacząć od czegoś prostego.',
    thirsStep2: 'Mój pierwszy nawyk wyglądał tak:',
    thirdStep3: '"Jak rano skończę myć zęby, to zrobię 1 min ćwiczeń"',
    thirsStep4: 'Zwróć uwagę, że określam, w jakiej sytuacji nawyk się aktywuje.',
    thirdStep5: 'Łączenie nawyków, które już istniją z nowymi to bardzo potężny lifehack',
    thirsStep6: 'Gdy tylko zaczynam rano myć zęby, pamiętam o ćwiczeniach. Tak działają nasze mózgi!',
    thirdStep7: 'Teraz pora na ciebie. Zdefiniuj swój pierwszy nawyk.',
    thirdStep8: 'Zdefiniuj swój pierwszy nawyk',
    weAddYourHabit: 'Dodaliśmy twój nawyk, zaraz przeniosę cie do aplikacji. Powodzenia! :)',
  },
  QR: {
    downloadQR: 'Pobierz kod QR',
    back: 'Powrót',
  },
  succesPage: {
    successMessage: 'Great success!!!',
    backToApp: 'Cofnij do aplikacji',
    typePassword: 'Please enter your password:',
  },
  menu: {
    settings: 'Ustawienia',
    habits: 'Dzienne Aktywności',
    feedback: 'Zostaw feedback',
    discord: 'Discord',
    news: 'News',
  },
  months: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  toShortLink: 'Link jest za krótki',
  notificationCloseButton: 'Zatwierdź',
  habitModalAlertHeader: 'Nowy nawyk został stworzony',
  habitModalAlertContent: 'Mozesz teraz wydrukować qr code dla tego nawyku, dzięki czemu mozesz go zaliczyć bez wchodzenia do aplikacji',
  gamefyRandomize: 'Losuj',
  gamefyAddNewReward: 'Dodaj nową nagrodę',
};
